<template>
  <aside
    :class="isExpanded ? 'w-64' : 'w-20'"
    class="fixed top-0 left-0 z-40 h-screen pt-14 transition-all duration-300 -translate-x-full bg-white border-r border-gray-200 md:translate-x-0 dark:bg-gray-800 dark:border-gray-700 overflow-hidden"
    @mouseenter="isExpanded = true"
    @mouseleave="collapseSidebar"
  >
    <div class="h-full flex flex-col py-4 overflow-y-auto bg-white dark:bg-gray-800">

      <!-- Main nav -->
      <nav class="flex-1 px-2 space-y-1">

        <!-- Sales -->
        <div v-if="role === 'admin' || role === 'sale'">
          <button
            type="button"
            @click="toggleMenu('sale')"
            :class="isExpanded ? 'justify-between px-3' : 'justify-center'"
            class="w-full flex items-center py-3 rounded-lg text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 transition-colors duration-200"
          >
            <div class="flex items-center min-w-0">
              <svg class="flex-shrink-0 w-6 h-6 text-orange-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M10 2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v2.382l1.447.723.005.003.027.013.12.056c.108.05.272.123.486.212.429.177 1.056.416 1.834.655C7.481 13.524 9.63 14 12 14c2.372 0 4.52-.475 6.08-.956.78-.24 1.406-.478 1.835-.655a14.028 14.028 0 0 0 .606-.268l.027-.013.005-.002L22 11.381V9a3 3 0 0 0-3-3h-2V5a3 3 0 0 0-3-3h-4Zm5 4V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1h6Zm6.447 7.894.553-.276V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-5.382l.553.276.002.002.004.002.013.006.041.02.151.07c.13.06.318.144.557.242.478.198 1.163.46 2.01.72C7.019 15.476 9.37 16 12 16c2.628 0 4.98-.525 6.67-1.044a22.95 22.95 0 0 0 2.01-.72 15.994 15.994 0 0 0 .707-.312l.041-.02.013-.006.004-.002.001-.001-.431-.866.432.865ZM12 10a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z" clip-rule="evenodd"/>
              </svg>
              <span v-show="isExpanded" class="ml-3 whitespace-nowrap font-medium text-base">Sales</span>
            </div>
            <svg v-show="isExpanded" :class="openMenus.sale ? 'rotate-180' : ''" class="flex-shrink-0 w-4 h-4 transition-transform duration-200" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
            </svg>
          </button>
          <ul v-show="isExpanded && openMenus.sale" class="mt-1 space-y-1 pl-11">
            <li v-for="menu in menus.filter(m => m.roleMenu === 'sale')" :key="menu.text">
              <button @click="pushMenu(menu.link)" class="w-full text-left px-3 py-2 text-sm font-medium text-gray-600 rounded-lg hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 whitespace-nowrap">
                {{ menu.text }}
              </button>
            </li>
          </ul>
        </div>

        <!-- Product Management -->
        <div v-if="role === 'admin' || role === 'pm'">
          <button
            type="button"
            @click="toggleMenu('pm')"
            :class="isExpanded ? 'justify-between px-3' : 'justify-center'"
            class="w-full flex items-center py-3 rounded-lg text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 transition-colors duration-200"
          >
            <div class="flex items-center min-w-0">
              <svg class="flex-shrink-0 w-6 h-6 text-cyan-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 17h6m-3 3v-6M4.857 4h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857H4.857A.857.857 0 0 1 4 9.143V4.857C4 4.384 4.384 4 4.857 4Zm10 0h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857h-4.286A.857.857 0 0 1 14 9.143V4.857c0-.473.384-.857.857-.857Zm-10 10h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857H4.857A.857.857 0 0 1 4 19.143v-4.286c0-.473.384-.857.857-.857Z"/>
              </svg>
              <span v-show="isExpanded" class="ml-3 whitespace-nowrap font-medium text-base">Product Management</span>
            </div>
            <svg v-show="isExpanded" :class="openMenus.pm ? 'rotate-180' : ''" class="flex-shrink-0 w-4 h-4 transition-transform duration-200" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
            </svg>
          </button>
          <ul v-show="isExpanded && openMenus.pm" class="mt-1 space-y-1 pl-11">
            <li v-for="menu in menus.filter(m => m.roleMenu === 'pm')" :key="menu.text">
              <button @click="pushMenu(menu.link)" class="w-full text-left px-3 py-2 text-sm font-medium text-gray-600 rounded-lg hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 whitespace-nowrap">
                {{ menu.text }}
              </button>
            </li>
          </ul>
        </div>

        <!-- Product Catalog (CS) -->
        <div v-if="role === 'admin' || role === 'cs'">
          <button
            type="button"
            @click="toggleMenu('cs')"
            :class="isExpanded ? 'justify-between px-3' : 'justify-center'"
            class="w-full flex items-center py-3 rounded-lg text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 transition-colors duration-200"
          >
            <div class="flex items-center min-w-0">
              <svg class="flex-shrink-0 w-6 h-6 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.03v13m0-13c-2.819-.831-4.715-1.076-8.029-1.023A.99.99 0 0 0 3 6v11c0 .563.466 1.014 1.03 1.007 3.122-.043 5.018.212 7.97 1.023m0-13c2.819-.831 4.715-1.076 8.029-1.023A.99.99 0 0 1 21 6v11c0 .563-.466 1.014-1.03 1.007-3.122-.043-5.018.212-7.97 1.023"/>
              </svg>
              <span v-show="isExpanded" class="ml-3 whitespace-nowrap font-medium text-base">Product Catalog</span>
            </div>
            <svg v-show="isExpanded" :class="openMenus.cs ? 'rotate-180' : ''" class="flex-shrink-0 w-4 h-4 transition-transform duration-200" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
            </svg>
          </button>
          <ul v-show="isExpanded && openMenus.cs" class="mt-1 space-y-1 pl-11">
            <li v-for="menu in menus.filter(m => m.roleMenu === 'cs')" :key="menu.text">
              <button @click="pushMenu(menu.link)" class="w-full text-left px-3 py-2 text-sm font-medium text-gray-600 rounded-lg hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 whitespace-nowrap">
                {{ menu.text }}
              </button>
            </li>
          </ul>
        </div>

        <!-- Configuration (admin only) -->
        <div v-if="role === 'admin'">
          <button
            type="button"
            @click="toggleMenu('admin')"
            :class="isExpanded ? 'justify-between px-3' : 'justify-center'"
            class="w-full flex items-center py-3 rounded-lg text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 transition-colors duration-200"
          >
            <div class="flex items-center min-w-0">
              <svg class="flex-shrink-0 w-6 h-6 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1Z"/>
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
              </svg>
              <span v-show="isExpanded" class="ml-3 whitespace-nowrap font-medium text-base">Configuration</span>
            </div>
            <svg v-show="isExpanded" :class="openMenus.admin ? 'rotate-180' : ''" class="flex-shrink-0 w-4 h-4 transition-transform duration-200" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
            </svg>
          </button>
          <ul v-show="isExpanded && openMenus.admin" class="mt-1 space-y-1 pl-11">
            <li v-for="menu in menus.filter(m => m.roleMenu === 'admin')" :key="menu.text">
              <button @click="pushMenu(menu.link)" class="w-full text-left px-3 py-2 text-sm font-medium text-gray-600 rounded-lg hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 whitespace-nowrap">
                {{ menu.text }}
              </button>
            </li>
          </ul>
        </div>

      </nav>

      <!-- Sign out -->
      <div class="mt-auto px-2 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button
          @click="logout"
          :class="isExpanded ? 'justify-start px-3' : 'justify-center'"
          class="w-full flex items-center py-3 rounded-lg text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 transition-colors duration-200 cursor-pointer"
        >
          <svg class="flex-shrink-0 w-6 h-6 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2"/>
          </svg>
          <span v-show="isExpanded" class="ml-3 whitespace-nowrap font-medium text-base">Sign out</span>
        </button>
      </div>

    </div>
  </aside>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'SidebarView',
  data() {
    return {
      isExpanded: false,
      openMenus: {
        sale: false,
        pm: false,
        cs: false,
        admin: false,
      },
    }
  },
  methods: {
    collapseSidebar() {
      this.isExpanded = false
      this.openMenus = { sale: false, pm: false, cs: false, admin: false }
    },
    toggleMenu(key) {
      this.openMenus[key] = !this.openMenus[key]
    },
    logout() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    },
    pushMenu(path) {
      this.$router.push(path)
    },
    hasCSMenu() {
      return this.menus.some(m => m.roleMenu === 'cs')
    },
  },
  computed: {
    ...mapGetters({
      menus: 'accessMenus',
      role: 'role',
    }),
    ...mapState({
      username: state => state.users.username,
      IS_USER_AUTHENTICATED: state => state.authenticated,
    }),
  },
}
</script>

<style></style>
